import React from "react";
import EstimatedConsumption from "./EstimatedConsumption";
import AnnualProductionValue from "./AnnualProductionValue";
import AnnualProductionQuantity from "./AnnualProductionQuantity";
import MonthlyImports from "./MonthlyImports";
import ImportExportValue from "./ImportExportValue";
import ImportExportQuantity from "./ImportExportQuantity";
import Top5ProducersExporters from "./Top5ProducersExporters";
import GlobalProduction from "./GlobalProduction";
import GlobalValue from "./GlobalValue";
import { thisBaseURL } from "../../utils/helper.js";

function ConsumptionTrade({foodAnswers, foodName}){
	let defaultSlug = foodAnswers.answerKeyValues["food_slug"];
	let answerKeyValues = foodAnswers.answerKeyValues;
	let importPattern = answerKeyValues['seasonal_us_import_patterns'];
	let importPatternYear = answerKeyValues['seasonal_us_import_patterns_year'];
	let importPatternSourceRef = answerKeyValues['seasonal_us_import_patterns_sources'];
	let importPatternNotes = answerKeyValues['seasonal_us_import_patterns_notes'];
	
	let antiDumping = answerKeyValues['active_anti_dumping_countervailing_duties'];
	let antiDumpingYear = answerKeyValues['active_anti_dumping_countervailing_duties_year'];
	let antiDumpingSourceRef = answerKeyValues['active_anti_dumping_countervailing_duties_sources'];
	let antiDumpingNotes = answerKeyValues['active_anti_dumping_countervailing_duties_notes'];
	
	return (
		<div className="question-grouping" id="consumption_production_and_trade">
		    <h2>Consumption, Production and Trade</h2>
			<EstimatedConsumption foodAnswers={{answerKeyValues}} foodName={foodName} />
			<AnnualProductionValue foodAnswers={{answerKeyValues}} foodName={foodName} />
			<AnnualProductionQuantity foodAnswers={{answerKeyValues}} foodName={foodName} />
			<div>
				<h3>
					United States Import Patterns
					{importPatternYear ? 
					<small>&nbsp;({importPatternYear})</small>
					: ""}
					{ importPatternSourceRef && importPatternSourceRef ? 
					<small className="superscript"><a href={thisBaseURL +"/foods/" +defaultSlug+"#"+importPatternSourceRef}>{importPatternSourceRef}</a></small>
					: ""}
				</h3>
				<p>{importPattern}</p>
				{importPatternNotes  ? 
				<p className="notes-info" style={{marginTop: "auto"}}>
				<em>{importPatternNotes}</em>
				</p>
				:""}
			</div>
			<MonthlyImports foodAnswers={{answerKeyValues}} foodName={foodName} />
			<ImportExportValue foodAnswers={{answerKeyValues}} />
			<ImportExportQuantity foodAnswers={{answerKeyValues}} />
			<Top5ProducersExporters foodAnswers={{answerKeyValues}} foodName={foodName} />
			<GlobalProduction foodAnswers={{answerKeyValues}} foodName={foodName} />
			<GlobalValue foodAnswers={{answerKeyValues}} foodName={foodName} />
			<div>
				<h3>
					Active anti-dumping/countervailing duties
					{antiDumpingYear ? 
					<small>&nbsp;({antiDumpingYear})</small>
					: ""}
					{ antiDumpingSourceRef && antiDumpingSourceRef >0? 
					<small className="superscript"><a href={thisBaseURL +"/foods/" +defaultSlug+"#"+antiDumpingSourceRef}>{antiDumpingSourceRef}</a></small>
					: ""}
				</h3>
				<p>{antiDumping}</p>
				{antiDumpingNotes  ? 
				<p className="notes-info" style={{marginTop: "auto"}}>
				<em>{antiDumpingNotes}</em>
				</p>
				:""}
			</div>
		</div>
	);
	
}
export default ConsumptionTrade;